import { render, staticRenderFns } from "./CompanyRLSDropdownFooter.vue?vue&type=template&id=72723fcf"
import script from "./CompanyRLSDropdownFooter.vue?vue&type=script&lang=js"
export * from "./CompanyRLSDropdownFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports